import React from 'react';

import {
  AvailablePieceJointeDto,
  ComputedResponseDtoListAvailableFilesEnum,
} from 'lib_api/lib/api/gen';

import Actions from 'components/ActionAndFileWrapper/Actions/Actions';
import AvailableFiles from 'components/ActionAndFileWrapper/AvailableFiles/AvailableFiles';

import { AvailableAction } from './types';

import './ActionAndFileWrapper.less';

export interface ActionAndFileWrapperType {
  filesList: ComputedResponseDtoListAvailableFilesEnum[];
  piecesJointesList: AvailablePieceJointeDto[];
  actions: AvailableAction[];
  dossierId: string;
}

const ActionAndFileWrapper = ({
  filesList,
  piecesJointesList,
  actions,
  dossierId,
}: ActionAndFileWrapperType): React.ReactElement => {
  return (
    <div className={'ActionsContainer'}>
      <AvailableFiles
        files={new Set(filesList)}
        piecesJointes={piecesJointesList}
        dossierId={dossierId}
      />
      {!!actions.length && <Actions actions={actions} />}
    </div>
  );
};

export default ActionAndFileWrapper;
